import { LocalizedString } from '../redux/application/application.types';

/**
 * Resolves a LocalizedString to a plain string for the given language.
 *
 * - A plain string is treated as the default (German) value and returned as-is.
 * - An object `{ de, en }` is resolved by language: for an English locale the
 *   English value wins (falling back to German), otherwise the German value
 *   wins (falling back to English).
 * - An empty object `{}` or a missing value resolves to `undefined`, so callers
 *   can apply their own explicit fallback (never render a raw key/path).
 *
 * `language` is the i18next locale (e.g. `de-FORMAL`, `en-FORMAL`); only the
 * `en` marker matters for content, since formal/informal differ in tone only.
 */
export function resolveLocalized(
    value: LocalizedString | undefined,
    language: string | undefined,
): string | undefined {
    if (value == null) {
        return undefined;
    }
    if (typeof value === 'string') {
        return value;
    }
    const resolved = language?.includes('en') ? value.en ?? value.de : value.de ?? value.en;
    return resolved ?? undefined;
}
